export default __webpack_public_path__ + "static/media/photo--sm--110.fe2ea092.jpg";